import { Button, colors } from '@spritz-finance/ui'
import React, { useState } from 'react'
import { DIRECT_PAY_OPENED_EVENT } from '../../../../analytics/events'
import { useAnalytics } from '../../../../context/useAnalytics'
import { Feature, useFeatureFlag } from '../../../../context/useFeatureFlag'
import { useWalletDialog } from '../../../../web3/connectDialog/WalletConnectDialogProvider'
import { useWeb3Connection } from '../../../../web3/Web3Provider'
import { Bill } from '../bills/Bills'
import { DirectPayType } from './context/DirectPayContext'
import { DirectPayDialog } from './DirectPayDialog'

type DirectPayButtonProps = {
    bill: Bill
    disabled?: boolean
    open: boolean
    setIsOpen: (boolean) => void
}

export const DirectPayButton: React.VFC<DirectPayButtonProps> = ({
    bill,
    disabled = false,
    open,
    setIsOpen,
}) => {
    const billPayEnabled = useFeatureFlag(Feature.BillPay)
    const { connected } = useWeb3Connection()
    const { openWalletConnectDialog } = useWalletDialog()
    const { trackAnalyticsEvent } = useAnalytics()

    const handleDirectPay = () => {
        trackAnalyticsEvent(DIRECT_PAY_OPENED_EVENT, {
            type: DirectPayType.BillPay,
        })
        if (connected) {
            setIsOpen(true)
        } else {
            openWalletConnectDialog(() => setIsOpen(true))
        }
    }

    return (
        <>
            <Button.CTA
                variant="gradient"
                onClick={handleDirectPay}
                color={colors.brand}
                disabled={!billPayEnabled || disabled}
            >
                Pay with crypto
            </Button.CTA>

            <DirectPayDialog
                open={open}
                type={DirectPayType.BillPay}
                onClose={() => setIsOpen(false)}
                account={{
                    accountId: bill.id,
                    provider: bill.provider,
                    name: bill.name,
                    amountDue: bill.amountDue,
                    ownedByUser: true,
                }}
                fullAccount={bill}
            />
        </>
    )
}
